function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  fill: "transparent",
  width: 283.464,
  height: 283.464
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  fill: "#FFFFFF",
  cx: 114.705,
  cy: 84.246,
  r: 28.461
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M144.068,140.553c-4.377-12.01-16.494-20.585-30.018-20.585c-17.29,0-31.307,14.017-31.307,31.307v129.191 h63.462V180.05l46.83,22.401l-9.03-64.522c-2.625-16.012-15.646-21.682-15.646-21.682c-13.886,5.079-28.769,4.515-28.769,4.515 c-0.867,1.286,1.693,2.73,1.693,2.73c2.429,1.903,7.48,1.772,7.48,1.772c2.823,0,8.663-0.459,8.663-0.459 c-1.706,5.185-3.741,8.4-3.741,8.4c4.726,3.216,11.63,7.718,11.63,7.718c0.709,0.485,3.464-0.893,3.464-0.893 c1.707-0.656,2.625,0.893,2.625,0.893l1.51,27.523L144.068,140.553z"
});

function SvgJag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 284,
    height: 284,
    viewBox: "-0.006 -0.016 284 284",
    enableBackground: "new -0.006 -0.016 284 284",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJag);
export default __webpack_public_path__ + "static/media/jag.89bd43d7.svg";
export { ForwardRef as ReactComponent };